import { SiteQaNote } from '../models/SiteQaNote';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

/**
 * 현장 QA 메모 API — QA 를 보는 모두가 같은 목록을 본다.
 * - list: 작성순(오래된 → 최신)
 * - create: body 가 공백이면 백엔드에서 400
 * - delete: admin/editor
 */
export class SiteQaNoteService {
  static async list(projectId: number): Promise<SiteQaNote[]> {
    const res = await apiClient.get<ApiListResponse<SiteQaNote>>(
      API_ENDPOINTS.SITE_MANAGEMENT.QA.NOTES.LIST(projectId),
    );
    return unwrapList(res, '메모 목록 조회 실패');
  }

  static async create(projectId: number, body: string): Promise<SiteQaNote> {
    const res = await apiClient.post<ApiItemResponse<SiteQaNote>>(
      API_ENDPOINTS.SITE_MANAGEMENT.QA.NOTES.CREATE(projectId),
      { body },
    );
    return unwrapItem(res, '메모 작성 실패');
  }

  static async delete(noteId: number): Promise<void> {
    const res = await apiClient.delete<ApiOkResponse>(API_ENDPOINTS.SITE_MANAGEMENT.QA.NOTES.DELETE(noteId));
    ensureOk(res, '메모 삭제 실패');
  }
}
